<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="order?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + order?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%" style="padding: 0px !important;">
                      <img style="width: 100%; height: 150px !important;" :src="`${getFileServerUrl}` + 'uploads/images/company/header/Invoice_Bill.png'" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- <tr>
                    <td colspan="100%">
                      <div class="text-center">
                        <h2 class="report-title">INVOICE</h2>
                      </div>
                    </td>
                  </tr> -->

                  <!-- Bill To / Ship To / Invoice Details Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box" style="font-size: 12px; width: 100%;">
                        <table style="width: 100%; border-collapse: collapse;">
                          <tbody>
                            <tr>
                              <td style="width: 33.33%; vertical-align: top; padding: 0 15px;">
                                <strong>BILL TO <br/>
                                {{ order.bill_to || '-' }}</strong>
                              </td>

                              <td style="width: 33.33%; vertical-align: top; padding: 0 10px;">
                                <strong>SHIP TO <br/>
                                {{ order.ship_to || '-' }}</strong>
                              </td>

                              <td style="width: 33.33%; vertical-align: top; padding: 0 10px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: -5px;">
                                  <tbody>
                                    <tr>
                                      <td style="padding: 2px 0; width: 65%;"><strong>Invoice No:</strong></td>
                                      <td style="padding: 2px 0; width: 35%;">{{ order.invoice_no || '-' }}</td>
                                    </tr>
                                    <tr>
                                      <td style="padding: 2px 0;"><strong>Invoice Date:</strong></td>
                                      <td style="padding: 2px 0;">{{ formattedDate(order.invoice_date) }}</td>
                                    </tr>
                                    <tr>
                                      <td style="padding: 2px 0;"><strong>Invoice Due Date:</strong></td>
                                      <td style="padding: 2px 0;">{{ formattedDate(order.invoice_due_date) }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>

                  <!-- Details Table -->
                  <tr>
                    <td colspan="100%">
                      <table class="dep-table order-table mt-5" style="width: 100%; border: none !important; border-collapse: collapse;">
                        <thead>
                          <tr style="background-color: #003d7a; color: #000;">
                            <th style="border: 1px solid #000; padding: 4px; text-align: center;">Description:</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 4px; width: 15%;">Price</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 4px; width: 10%;">QTY.</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 4px; width: 15%;">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, idx) in order.details" :key="idx">
                            <td style="border: 1px solid #000; padding: 4px;">{{ row.item_description }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 4px;">{{ row.price }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 4px;">{{ row.quantity }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 4px;">{{ row.total }}</td>
                          </tr>
                          <tr style="font-weight: bold; background-color: #f2f2f2;">
                            <td style="border: 1px solid #000; padding: 4px; text-align: center;">
                              Total
                            </td>
                            <td style="border: 1px solid #000; padding: 4px;"></td>
                            <td class="text-center" style="border: 1px solid #000; padding: 4px;">
                              {{ totalQty }}
                            </td>
                            <td class="text-center" style="border: 1px solid #000; padding: 4px;">
                              {{ grandTotal }}
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <!-- Total Due Section -->
                      <v-row style="margin-top: 10px;">
                        <v-col cols="6">
                          <div style="padding: 4px; background-color: #f5f5f5; text-align: left; display: flex; justify-content: space-between;">
                            <strong style="font-size: 14px; text-align: left;">Total Payable amount at now {{ convertNumberToWords(grandTotal) }}</strong>
                          </div>
                        </v-col>

                        <v-col cols="6">
                          <div style="border: 1px solid #000; padding: 4px; background-color: #f5f5f5; text-align: center; justify-content: space-between; margin-right: -12px;">
                            <strong>Total Due: {{ $number_format(grandTotal) || '-' }} {{ order.currency?.code ?? 'USD' }}</strong>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                  <!-- Additional Condition -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; background-color: #ffffff;"><strong>ADDITIONAL CONDITION:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; min-height: 80px; vertical-align: top; white-space: pre-wrap; word-wrap: break-word;">
                              {{ order?.additional_condition }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <!-- Bank Details and Remarks Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <v-row class="mt-4">
                        <v-col cols="6">
                          <div style="font-size: 14px; line-height: 1.6;">
                            <strong style="color: #c41e1e;">Bank Details:</strong><br/>
                            <strong>Bank Name: </strong>{{ order.bank_name || '-' }}<br/>
                            <strong>Account Number: </strong>{{ order.bank_ac_no || '-' }}<br/>
                            <strong>Account Name: </strong>{{ order.bank_ac_name || '-' }}<br/>
                            <strong>Branch Name: </strong>{{ order.branch_name || 'Principal Branch' }}<br/>
                            <strong>Routing No: </strong>{{ order.routing_no || '-' }}<br/>
                            <strong>SWIFT Code: </strong>{{ order.swift_code || '-' }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div :style="{ padding: '2px', marginTop: '40px', width: '200px', float: 'right', paddingTop: !withSignature ? '60px' : '0' }">
                              <img v-if="withSignature" :src="`${getFileServerUrl}` + 'uploads/images/company/signature-without-bg.png'" style="width: 150px; height: 60px;" alt="">
                              <!-- <div style="text-transform: capitalize; font-weight: bold; font-size: 9px;">Date: {{ formatDateView(new Date) }}</div> -->
                              <div style="border-bottom: 1px solid #000; margin: 0 0 8px 0; width: 140px; margin-top: -15px; margin-bottom: 5px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">AUTHORIZED SIGNATURE</div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">{{ order?.branch?.company?.company_owner_name }},</div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">{{ order?.branch?.company?.owner_designation?.name }}</div>
                            </div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%; height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer" :style="invoiceHeader ? { borderTop: '1px solid rgba(196, 30, 30, 0.5)' } : {}">
              <img v-if="order?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; height: 80px; display: block; margin-bottom: -15px;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row class="d-print-none mt-4">
      <v-col align="start" cols="12">
        <v-checkbox
          label="With signature"
          v-model="withSignature"
          density="compact"
          variant="outlined"
          hide-details
          single-line
          color="primary"
          :true-value="1"
          :false-value="0"
        ></v-checkbox>
      </v-col>
      <v-col align="center" cols="12">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import convertNumberToWords from "@/plugins/numberToWord";
import formattedDate from "@/plugins/dateFormatter";

const store = useStore();
const route = useRoute();

const withSignature = ref(1);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const order = ref({
  branch: {},
  details: []
});

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

// fetch invoice bill
async function fetchDetails(id) {
  const res = await store.dispatch("getInvoiceBillById", { id });
  order.value = res.data.data;
}

const totalQty = computed(() => {
  return order.value.details.reduce((sum, row) => {
    return sum + Number(row.quantity || 0);
  }, 0);
});

const grandTotal = computed(() => {
  return order.value.details
    .reduce((sum, row) => sum + Number(row.total || 0), 0)
    .toFixed(0);
});



const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Invoice Bill</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }
  
        html, body {
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0 30px; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        // img { 
        //   max-width: 100% !important; 
        //   height: auto !important; 
        // }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin: -10px 0px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  fetchDetails(route.params.id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
